// @flow

import authBehavior from 'app/beta-editor/pages/behaviors/auth';
import createTemplateBehavior from 'app/beta-editor/pages/behaviors/createTemplate';
import fieldsBehavior from 'app/beta-editor/pages/behaviors/fields';
import filterBehavior from 'app/beta-editor/pages/behaviors/filter';
import overviewBehavior from 'app/beta-editor/pages/behaviors/overview';
import pathRulesBehavior from 'app/beta-editor/pages/behaviors/pathRules';
import pathSettingsBehavior from 'app/beta-editor/pages/behaviors/pathSettings';
import sampleBehavior from 'app/beta-editor/pages/behaviors/sample';
import setupBehavior from 'app/beta-editor/pages/behaviors/setup';
import webhookBehavior from 'app/beta-editor/pages/behaviors/webhook';
import welcomeBehavior from 'app/beta-editor/pages/behaviors/welcome';
import { PATH_SETTINGS_PAGE } from 'app/beta-editor/constants';

import type { FlowPageKey } from 'app/beta-editor/types';

import type { Behavior } from './types';

type PageBehaviorsMap = { [FlowPageKey]: { behavior: Behavior } };

const defaultBehavior = {
  isLoading: () => false,
};

const supplyDefaults = behavior => ({ ...defaultBehavior, ...behavior });

const pageBehaviorsMap: PageBehaviorsMap = {
  setup: { behavior: supplyDefaults(setupBehavior) },
  auth: { behavior: supplyDefaults(authBehavior) },
  webhook: { behavior: supplyDefaults(webhookBehavior) },
  fields: { behavior: supplyDefaults(fieldsBehavior) },
  filter: { behavior: supplyDefaults(filterBehavior) },
  [PATH_SETTINGS_PAGE]: { behavior: supplyDefaults(pathSettingsBehavior) },
  rules: { behavior: supplyDefaults(pathRulesBehavior) },
  sample: { behavior: supplyDefaults(sampleBehavior) },
  __create_template: { behavior: supplyDefaults(createTemplateBehavior) },
  overview: { behavior: supplyDefaults(overviewBehavior) },
  welcome: { behavior: supplyDefaults(welcomeBehavior) },
};

export default pageBehaviorsMap;
